import { isArray } from 'util';
import { ZollerFocus } from '../zoller-focus';

export class ZollerFocusBuilder {
  static fromJson(json) {
    return (json)
      ? new ZollerFocus(
        json.hash,
        json.name
      )
      : null;
  }

  static fromList(list) {
    return (isArray(list)) ? list.map(ZollerFocusBuilder.fromJson) : [];
  }
}



// WEBPACK FOOTER //
// /var/www/borneo/prod/borneo_app/src/app/core/models/builders/zoller-focus.builder.ts